import {
	DriverScheduleTripTypeEnum,
	NormalizedScheduledLeg,
} from '@mopla/data-models';

/** The leg the driver may start: the first one with only breaks, or nothing, ahead. Expects finished items filtered out. */
export const getNextStartableLegId = (
	legs: NormalizedScheduledLeg[]
): string | null => {
	for (const leg of legs) {
		if (leg.ref === DriverScheduleTripTypeEnum.BREAK) continue;
		if (leg.ref === DriverScheduleTripTypeEnum.VEHICLE_CHECK && leg.checkDone)
			continue;

		return leg.ref === DriverScheduleTripTypeEnum.LEG
			? leg.scheduledLegId ?? null
			: null;
	}

	return null;
};
